import React from 'react';
import { useTranslation } from 'react-i18next';
import { type Header } from '@tanstack/react-table';

import { FilterIcon } from '../../../../assets';
import { Button } from '../../../Button';
import { Popover } from '../../../Popover';
import { Typography } from '../../../Typography';
import { FilterContent } from './FilterContent';

import styles from './FilterButton.module.scss';

export interface IFilterButtonProps {
    header: Header<any, unknown>;
}

export const FilterButton: React.FC<IFilterButtonProps> = ({ header }) => {
    const { t } = useTranslation();
    const filter = header.column.columnDef.meta?.filtering;

    if (header.column.getCanFilter() === false || filter === undefined) return null;

    const active = !!header.column.getFilterValue();
    const handleClearFilter = () => {
        header.column.setFilterValue(null);
    };
    return (
        <Popover
            label={typeof header.column.columnDef.header === 'string' ? header.column.columnDef.header : ''}
            trigger={<FilterIcon height={16} width={16} className={styles.filterButton} data-active={active} />}
        >
            <FilterContent header={header} />
            <Button variant="ghost" size="small" style={{ marginTop: 16 }} onClick={handleClearFilter}>
                <Typography color="inherit" fontWeight="semibold">
                    {t('table.filtering.clear')}
                </Typography>
            </Button>
        </Popover>
    );
};
